import React, { useContext, useState } from "react";
import HeadingText from "./HeadingText";
import SignatureBox from "../../components/SignatureBox";
import { AuditTrailViewContext } from "../../AuditTrailViewContext";
import { formatAsTimezoneLabel } from "../../../../util/AppUtils";
import AppBar from "../../../../common/AppBar";
import { generateSHA256 } from "../../../../util/generateSHA256";

const ActionCommonInfo = () => {
  const { data } = useContext(AuditTrailViewContext);

  const date = formatAsTimezoneLabel(data.audit_date);

  const [dataIntegrity, setDataIntegrety] = useState({
    clickedVerified: false,
    isValid: false,
  });

  const verifyDataIntegrity = () => {
    const obj = { clickedVerified: true };
    let {
      user_ref,
      ip_address,
      device_info,
      audit_date,
      version_content,
      action,
      comment,
    } = data;
    // Convert buffer array to string if signature.data exists
    let sign = "";
    if (data.signature?.data && Array.isArray(data.signature.data)) {
      sign = String.fromCharCode(...data.signature.data);
    } else if (version_content?.signature) {
      sign = version_content.signature;
    }
    // if (version_content.action_to_show === "LOGIN") {
    //   user_ref = "";
    // }
    let hash = generateSHA256(
      user_ref + ip_address + device_info + audit_date + sign + action + comment
    );
    if (hash === data.hash) {
      obj.isValid = true;
    } else {
      hash = generateSHA256(
        user_ref +
          ip_address +
          device_info +
          audit_date +
          sign +
          version_content.action_to_show +
          comment
      );
      if (hash === data.hash) {
        obj.isValid = true;
      } else {
        obj.isValid = false;
      }
    }
    setDataIntegrety(obj);
  };

  const heading = <HeadingText heading="Activity" text={data.action} />
  
  return (
    <>
      <AppBar
        title={"Audit Trail Entry on " + date}
        showTablesDropdown={false}
        showBlackTitle={true}
        showProfileButton={false}
        buttons={[]}
      />
      <HeadingText heading="Audit Trail ID" text={data.audit_trail_id} />

      <HeadingText heading="Timestamp" text={date} />

      <HeadingText
        heading="User Name"
        text={`${data.first_name} ${data.last_name}`}
      />

      {data?.version_content?.action_to_show === "LOGIN" && data?.version_content?.is_signature_included ? <>
        <HeadingText heading="Signature">
          <SignatureBox fullwidth={false} signature={data.signature.data} />
        </HeadingText>
      </>:""}

      <HeadingText heading="IP Address" text={data.ip_address} />

      <HeadingText heading="Device Information" text={data.device_info} />

      <HeadingText heading="Hash" text={data.hash}>
        &nbsp;&nbsp;
        {!dataIntegrity.clickedVerified && (
          <button className="btn-outline-primary" onClick={verifyDataIntegrity}>
            Verify Data Integrity
          </button>
        )}
        {dataIntegrity.clickedVerified && (
          <>
            <b>
              {dataIntegrity.isValid ? (
                <span style={{ color: "#00c853" }}>Verified ✓</span>
              ) : (
                <span style={{ color: "#b71c1c" }}>Data has been lost ⚠️</span>
              )}
            </b>
          </>
        )}
      </HeadingText>

      {
        data?.version_content?.action_to_show === "DELETE_TASK" && (<>{heading}</>)
      }
      {data?.version_content?.action_to_show === "LOGIN" ||
      data?.version_content?.action_to_show === "LOGOUT" ||
        (data?.version_content?.action_to_show.includes("CREATE_") 
        && (
          data?.version_content?.action_to_show !== "CREATE_PROCEDURE_REVISION" &&
          data?.version_content?.action_to_show !== "CREATE_SECTION" &&
          data?.version_content?.action_to_show !== "CREATE_STEP" &&
          data?.version_content?.action_to_show !== "CREATE_ATTACHMENT" &&
          data?.version_content?.action_to_show !== "CREATE_CANVAS" &&
          data?.version_content?.action_to_show !== "CREATE_RICH_TEXT" &&
          data?.version_content?.action_to_show !== "CREATE_VIDEO" &&
          data?.version_content?.action_to_show !== "CREATE_FORM" &&
          data?.version_content?.action_to_show !== "CREATE_SUBSTEP"
        )) ?(
          <>
            {heading}
          </>
        ):""}

        {data?.version_content?.action_to_show === "LOGIN" || data?.version_content?.action_to_show === "LOGOUT" ?(
          <>
            <HeadingText heading="Comment" text={data.comment} />
          </>
        ):""}
    </>
  );
};

export default ActionCommonInfo;
